import { useState } from 'react';
import styled from '@emotion/styled';
import { fontSizes, theme } from '../../utils';
import { useIntl } from 'react-intl';
import { OldTooltip } from '@/components/sushi__old';
import { InfoIcon } from '../Icon';

type NumberInputProps = {
  min?: number;
  max?: number;
  defaultValue?: number;
  label?: string;
  optional: boolean;
  tooltip?: string;
  onChange?: (arg0: number) => void;
};

const LabelLine = styled.span`
  display: flex;
  align-items: baseline;
  font-size: ${fontSizes['xmedium']};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.palette.common.white};
  margin-bottom: 6px;
`;
const Label = styled.span`
  display: flex;
  align-items: baseline;
  font-size: ${fontSizes['xmedium']};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.palette.common.white};
`;

const Optional = styled.span`
  color: ${theme.palette.grey[400]};
  font-size: ${fontSizes['small']};
  margin-left: 5px;
  margin-right: 5px;
`;

export const NumberInput = ({
  min,
  max,
  defaultValue,
  onChange,
  label,
  optional = false,
  tooltip,
}: NumberInputProps) => {
  const [currentValue, setCurrentValue] = useState(defaultValue || null);
  const i18n = useIntl();

  const changeValue = (newValue: number) => {
    let checkedValue = newValue;
    if (min !== undefined && checkedValue < min) {
      checkedValue = min;
    }
    if (max !== undefined && checkedValue > max) {
      checkedValue = max;
    }

    setCurrentValue(checkedValue);
    if (onChange) {
      onChange(checkedValue);
    }
  };

  return (
    <div>
      {label || optional || tooltip ? (
        <LabelLine>
          {label && <Label>{label}</Label>}
          {optional && (
            <Optional>{i18n.formatMessage({ id: 'components.input.optional' })}</Optional>
          )}
          {tooltip && (
            <OldTooltip
              html={
                <div className="tooltip text-white text-12 font-semibold rounded-md bg-grey-500 p-2">
                  {tooltip}
                </div>
              }
            >
              <span className="relative" style={{ top: '3px' }}>
                <InfoIcon size="xsmall" color={theme.palette.grey[400]} />
              </span>
            </OldTooltip>
          )}
        </LabelLine>
      ) : null}
      <div className="lolol flex justify-between border border-grey-500" style={{ height: '48px' }}>
        <div className="flex w-4 justify-between items-center">
          <span></span>
          {currentValue}
          <span></span>
        </div>
        <div className="flex">
          <span
            className="mr-1 flex w-5 cursor-pointer justify-between bg-grey-800 rounded-sm text-20 items-center unselectable"
            onClick={() => {
              changeValue(currentValue - 1);
            }}
          >
            <span></span>
            <span>-</span>
            <span></span>
          </span>
          <span
            className="flex w-5 justify-between cursor-pointer bg-grey-800 rounded-sm text-20 items-center unselectable"
            onClick={() => {
              changeValue(currentValue + 1);
            }}
          >
            <span></span>
            <span>+</span>
            <span></span>
          </span>
        </div>
        <style jsx>{`
          .lolol {
            padding: 5px;
            border-radius: 5px;
            background-color: ${theme.palette.grey[650]};
          }
        `}</style>
      </div>
    </div>
  );
};
